import { reverse } from 'ramda';
/**
 * Формирует уникальные инпуты и лейблы для радио кнопок
 * @param id - идентификатор вопроса
 * @param answers - варианты ответов
 * @param changeHandler - нажатие на кнопку
 * @returns {Array}
 */
export const getInputAndLabels = ({
  id,
  answers,
  changeHandler
}) => {
  const inputAndLabels = [];
  reverse(answers).forEach(answer => {
    const answerId = answer.id;
    const inputKey = `answer-${answerId}-input`;
    const labelKey = `answer-${answerId}-label`;
    const name = `question-${id}`;
    inputAndLabels.push(/*#__PURE__*/React.createElement("input", {
      id: answerId,
      key: inputKey,
      name: name,
      type: "radio",
      onClick: () => changeHandler(answer),
      defaultValue: answer.id
    }));
    inputAndLabels.push(
    // eslint-disable-next-line
    /*#__PURE__*/
    React.createElement("label", {
      key: labelKey,
      htmlFor: answerId
    }));
  });
  return inputAndLabels;
};